import { Topics } from "./Topics.component";

export { Topics };
